import { Box, Flex } from '@chakra-ui/react';
import './nav.css'
import Banner from './Banner'
import Slider from './Slider'
import NavOption from "./NavOption"
import logo from './logo.jpg'

const Nav = ({...props}) => {
    return <Box {...props}>
            <Banner
                bg="zpurple.200"
            />

	         <Slider
                bg="zpurple.200"
            />

			<Box
                mt="2px"
                bg="zpurple.400"
                pb="0"
            >
                
                <Flex
                    overflowX={{base: "scroll", md: "hidden"}}
                    alignContent="center"
                    justifyContent={{base: "", sm: "center"}}
                >

                    <NavOption
                        path={"/juegos"}
                    >
                        Juegos
                    </NavOption>
                    <NavOption
                        path={"/proceso"}
                    >
                        Proceso
                    </NavOption>
                    <NavOption
                        path={"/"}
                    >
						<center>
							<img src={logo}  width="65" height="65" />
							Inicio
						</center>
                        
                    </NavOption>						
                    <NavOption
                        path={"/recursos"}
                    >
                        Recursos
                    </NavOption>
                    <NavOption
                        path={"/Contactos"}
                    >
                        Contactos
                    </NavOption>
                </Flex>
            </Box>
			
    </Box> 
}

export default Nav;